import { parseDomain, ParseResultType } from "parse-domain";

const getCookieDomain = () => {
  let cookieDomain;
  try {
    const parseResult = parseDomain(window.location.hostname);
    if (parseResult.type === ParseResultType.Listed) {
      const { domain, labels } = parseResult;
      if (domain === "localhost") {
        cookieDomain = "localhost";
      } else if (labels.includes("ngrok")) {
        cookieDomain = ".sa.ngrok.io";
      } else {
        cookieDomain = window.location.hostname;
      }
    } else {
      cookieDomain = window.location.hostname;
    }
  } catch (e) {
    cookieDomain = "rtabak.com.ar";
  }

  return cookieDomain;
};

export const createCookie = (
  cookieName: string,
  cookieValue: string,
  hourToExpire: number
) => {
  let date = new Date();
  const cookieDomain = getCookieDomain();

  date.setTime(date.getTime() + hourToExpire * 60 * 60 * 1000);
  document.cookie = `${cookieName}=${cookieValue}; Domain=${cookieDomain}; expires = ${date.toUTCString()}; path=/`;
};

export const deleteCookie = (cookieName: string) => {
  const cookieDomain = getCookieDomain();
  document.cookie = `${cookieName}=; Domain=${cookieDomain}; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
};

export const getCookie = (cookieBase: any, cname: string) => {
  if (!cookieBase || cookieBase === "") return "";

  let name = cname + "=";
  let decodedCookie = decodeURIComponent(cookieBase);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const EXPIRE_IN_A_YEAR = 8760;
